import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { PowerbiReporteComponent } from './components/powerbi-reporte/powerbi-reporte.component';
import { FullscreenDivComponent } from './components/fullscreen-div/fullscreen-div.component';
import { MenuItemComponent } from './components/menu-items/menu-item/menu-item.component';
import { MenuDropdownComponent } from './components/menu-items/menu-dropdown/menu-dropdown.component';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [
    PowerbiReporteComponent,
    FullscreenDivComponent,
    MenuItemComponent,
    MenuDropdownComponent,
  ],
  imports: [CommonModule, PowerBIEmbedModule, RouterModule],
  exports: [
    PowerbiReporteComponent,
    PowerBIEmbedModule,
    FullscreenDivComponent,
    MenuItemComponent,
    MenuDropdownComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {  }
